export default "__VITE_ASSET__DZfb0sze__"